module.exports = __webpack_public_path__ + "videos/hero_en.700dc36.mp4";